export function getCookie(cookieName: string): string {
  // return the value or an empty string
  if (document.cookie.length > 0) {
    let cookieStart: number = document.cookie.indexOf(cookieName + '=');
    if (cookieStart !== -1) {
      cookieStart = cookieStart + cookieName.length + 1;
      let cookieEnd: number = document.cookie.indexOf(';', cookieStart);
      if (cookieEnd === -1) {
        cookieEnd = document.cookie.length;
      }

      // Return decoded value and trip beginning and end double quotes
      return decodeURIComponent(document.cookie.substring(cookieStart, cookieEnd)).replace(/(^")|("$)/g, '');
    }
  }
  return '';
}

export function setCookie(key: string, value: string): void {
  document.cookie = key + '=' + encodeURIComponent(value) + ';path/';
}

export class StringCookie {
  constructor(protected keyName: string) {}

  public set(val: string): void {
    setCookie(this.keyName, val);
  }

  public clear(): void {
    setCookie(this.keyName, '');
  }

  public get(): string {
    return getCookie(this.keyName);
  }
}

export class ObjectCookie {
  constructor(protected keyName: string) {}

  public set(val: any): void {
    setCookie(this.keyName, JSON.stringify(val));
  }

  public clear(): void {
    setCookie(this.keyName, '');
  }

  public get(): any {
    const result = getCookie(this.keyName);
    if (!result) {
      return '';
    }
    return JSON.parse(result);
  }
}
